import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import TeamForm from "./TeamForm";
export default class TeamFormWrapper extends Component {
    constructor(props) {
        super(props);
        this.renderBackButton = () => {
            if (this.getId()) {
                return (_jsx("a", { href: `/aviso/team/show/${this.getId()}`, className: "text-decoration-none", title: "Back to details", children: _jsx("span", { className: "fal fa-arrow-circle-left", "aria-hidden": true }) }));
            }
            return (_jsx("a", { href: "/aviso/team/index", className: "text-decoration-none", title: "Back to list", children: _jsx("span", { className: "fal fa-arrow-circle-left", "aria-hidden": true }) }));
        };
        this.getId = () => this.props.match.params.id;
        this.state = {
            showSuccess: false,
            showError: false,
            error: "",
        };
    }
    render() {
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsxs("h1", { className: "title float-left", children: [this.renderBackButton(), " ", this.getId() ? "Edit" : "New", " Team"] }) }), _jsxs("div", { id: "create-team", role: "main", children: [_jsx(TeamForm, { teamId: this.getId(), onSave: () => this.setState({ showSuccess: true, showError: false }), 
                            // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                            onError: (error) => this.setState({ showSuccess: false, showError: true, error }), onChange: () => this.setState({ showSuccess: false, showError: false }) }), this.state.showError && (_jsx("div", { className: "alert alert-danger", children: this.state.error
                                ? `Could not create team.${this.state.error}`
                                : "There was an error creating that team." })), this.state.showSuccess && (_jsx("div", { className: "alert alert-success", children: "Team saved. " }))] })] }));
    }
}
